import axios from "axios";

export const getDashboard = ({ uen, target, id, language, token, year }) => {
  const requestUrl = `/data/dashboard`;

  let params = {
    uen: uen,
    target: target,
    dashboardId: id,
    language: language,
    year: year,
    access_token: token
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getGeneralAssociationDashboard = ({ uen }) => {
  const requestUrl = `/data/dashboard/association`;

  let params = {
    uen
  };

  return axios.get(requestUrl, {
    params
  });
};

export const associateDashboardToFormLegal = ({ association }) => {
  const requestUrl = `/data/dashboard/associate`;

  var formData = new FormData();

  formData.append("created", JSON.stringify(association));

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/dashboard.js